import { useQuery } from 'hooks/useCustomQuery';
import { getTRSRegistration } from '@/API/TRSRegistration/getTRSRegistration';

const useGetTRSRegistration = (registrationID) => {
    return useQuery({
        queryKey: ['TRSRegistration', registrationID],
        queryFn: async () => {
            try {
                const response = await getTRSRegistration(registrationID);
                return response.data;
            } catch (error) {
                console.error('Error fetching TRS registration:', error);
                throw error;
            }
        },
        enabled: !!registrationID,
        retry: 1,
        cacheTime: 10 * 60 * 1000, // 10 minutes
        refetchOnWindowFocus: false,
    });
};

export default useGetTRSRegistration;
